import React, {Component} from 'react';
import connect from 'react-redux/es/connect/connect';
import getText from 'AppUtils/language';

import MenuComponent from "./MenuComponent";
import { appGetConfig, appGetInterfaceLang, uiGetSection } from "../../store/selectors";
import {authLogout} from "../../containers/auth/store/actions";
import {appLoadTranslations, uiRedirect, uiToggleModal} from "../../store/actions";
import {userLoadUnsubscribe} from "../../containers/user/store/actions";

const stateToProps = state => ({
	section: uiGetSection(state),
	appGetConfig: appGetConfig(state),
	appGetInterfaceLang: appGetInterfaceLang(state),
});

const actionsToProps = dispatch => ({
	uiToggleModal: (target, options, content = {}) => dispatch(uiToggleModal(target, options, content)),
	authLogout: () => dispatch(authLogout()),
	appLoadTranslations: (data) => dispatch(appLoadTranslations(data)),
	uiRedirect: (url) => dispatch(uiRedirect(url)),
	userLoadUnsubscribe: () => dispatch(userLoadUnsubscribe()),
});

@connect(stateToProps, actionsToProps)
class MenuContainer extends Component {
	constructor(props) {
		super(props);

		const currentLang = JSON.parse(localStorage.getItem('lang')) || '';

		this.state = {
			currentLanguage: currentLang,
			modalLanguagesIsOpen: false,
		}
	}

	handleSubmitLanguage = () => {
		this.props.appLoadTranslations({lang: this.state.currentLanguage});
		localStorage.setItem('lang', JSON.stringify(this.state.currentLanguage));
		this.toggleModal(false);
	}

	handleChangeLanguage = (e) => {
		const languageValue = e.target.value;

		this.setState({
			currentLanguage: e.target.value
		});
	}

	toggleModal = (value) => {
		this.setState({
			modalLanguagesIsOpen: value
		})
	}

	openModal = (title, message, button, buttonText, button2, button2Text, restrictClose, callback, callback2) => {
		this.props.uiToggleModal({}, { toggle: true }, { title, message, button, buttonText, button2, button2Text, restrictClose, callback, callback2 });
	};

	handleUnsubscribe = () => {
		this.openModal(getText('Unsubscribe'), getText('Please send a sms to 1234 in order to unsubscribe.'), true, getText('Ok'), false, false, false, () => {
			this.props.uiToggleModal({}, { toggle: false }, {});
		});
	}

	render() {
		return (
		  <MenuComponent
			key={this.props.appGetInterfaceLang}
			appGetConfig={this.props.appGetConfig}
			showMenu={this.props.showMenu}
			toggleMenu={this.props.toggleMenu}
			section={this.props.section}
			authLogout={this.props.authLogout}
			modalLanguagesIsOpen={this.state.modalLanguagesIsOpen}
			toggleModal={this.toggleModal}
			currentLanguage={this.state.currentLanguage}
			handleChangeLanguage={this.handleChangeLanguage}
			handleSubmitLanguage={this.handleSubmitLanguage}
			lang={this.props.appGetInterfaceLang}
			generate={this.props.generate}
			handleUnsubscribe={this.handleUnsubscribe}
		  />
		);
	}
}

export default MenuContainer;